import { render, staticRenderFns } from "./CollaboratoreForm.vue?vue&type=template&id=d0848788"
import script from "./CollaboratoreForm.vue?vue&type=script&lang=js"
export * from "./CollaboratoreForm.vue?vue&type=script&lang=js"
import style0 from "./CollaboratoreForm.vue?vue&type=style&index=0&id=d0848788&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports